export default __webpack_public_path__ + "efff8279c8bcd863ffe7ccb571c8abf7.png";